query OrganizationId($cloudIds: [ID!]!) {
  tenantContexts(cloudIds: $cloudIds) {
    orgId
  }
}
